import apiClient from './client'
import { Grupo, GrupoCreate } from '../types/api'
import { ensureArray } from '../utils/array'
import { createLogger } from '../utils/logger'

const logger = createLogger('gruposApi')

export const gruposApi = {
  list: async (options?: { includeInactive?: boolean; status?: string }): Promise<Grupo[]> => {
    const params: Record<string, unknown> = {}
    if (options?.status) {
      params.status = options.status
    } else if (!options?.includeInactive) {
      params.status = 'A'
    }

    logger.debug('Iniciando chamada com params:', params)
    
    try {
      const response = await apiClient.get<Grupo[]>('/grupos', { params })
      const rawData: unknown = response.data
      
      logger.debug('Resposta completa:', {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        hasData: !!rawData,
        dataType: Array.isArray(rawData) ? 'array' : typeof rawData,
        dataLength: Array.isArray(rawData) ? rawData.length : 'N/A',
        dataConstructor: (rawData as any)?.constructor?.name,
        data: rawData
      })
      
      // Garantir que sempre retornamos um array
      if (!rawData) {
        logger.warn('Resposta sem data, retornando array vazio')
        return []
      }
      
      // Se já é um array, retornar diretamente
      if (Array.isArray(rawData)) {
        logger.debug('response.data é array com', rawData.length, 'itens, retornando diretamente')
        return rawData as Grupo[]
      }
      
      // Se não é array, tentar converter
      logger.warn('response.data não é array, tipo:', typeof rawData, 'constructor:', (rawData as any)?.constructor?.name)
      const result = ensureArray<Grupo>(rawData)
      logger.debug('Resultado após ensureArray:', result.length, 'grupos')
      
      return result
    } catch (error: any) {
      logger.error('Erro ao buscar grupos:', error)
      logger.error('Status:', error.response?.status)
      logger.error('Data:', error.response?.data)
      // Se for erro 401/403, deixar propagar para o interceptor tratar
      if (error.response?.status === 401 || error.response?.status === 403) {
        throw error
      }
      // Para outros erros, retornar array vazio
      return []
    }
  },

  get: async (id: number): Promise<Grupo> => {
    const response = await apiClient.get<Grupo>(`/grupos/${id}`)
    return response.data
  },

  create: async (data: GrupoCreate): Promise<Grupo> => {
    const response = await apiClient.post<Grupo>('/grupos', data)
    return response.data
  },

  update: async (id: number, data: Partial<GrupoCreate>): Promise<Grupo> => {
    const response = await apiClient.put<Grupo>(`/grupos/${id}`, data)
    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/grupos/${id}`)
  },
}


